export function getView(state) {
  return state === 'NO_SHOW' ? 'NoShow' : 'No'
}
